export class Formaters {
    formatE(e: any) {
        const a1 = '3C6120687265663D226D61696C746F3A';
        const a2 = '223E';
        const a3 = '3C2F613E';
        var s1 = '';
        var s2 = '';
        var s3 = '';
        var s4 = '';
        var num = parseInt(e.substr(0, 2));
        e = e.substr(2);

        for (var n1 = 0; n1 < a1.length; n1 += 2) {
            s1 += String.fromCharCode(parseInt(a1.substr(n1, 2), 16));
        }

        for (var n2 = 0; n2 < e.length; n2 += 2) {
            s2 += String.fromCharCode(parseInt(e.substr(n2, 2), 16));

            if ((n2 + 2) / 2 === num) {
                s2 += String.fromCharCode(parseInt('40', 16));
            }
        }

        for (var n3 = 0; n3 < a2.length; n3 += 2) {
            s3 += String.fromCharCode(parseInt(a2.substr(n3, 2), 16));
        }

        for (var n4 = 0; n4 < a3.length; n4 += 2) {
            s4 += String.fromCharCode(parseInt(a3.substr(n4, 2), 16));
        }

        return (s1 + s2 + s3 + s2 + s4);
    }

    address(address: any) {
        switch (address.countryCode) {
            case 'SE':
            default: {
                const co = address.careOf ? `${address.careOf}<br />` : '';
                const row1 = address.street;
                const row2 = address.street2 ? `${address.street2}<br />` : '';
                const row3 = `${address.countryCode}-${address.postalCode} ${address.city.toUpperCase()}`;

                return `${co}${row1}${row2}<br />${row3}`
            }
        }
        return "Address"
    }
}